import * as React from 'react';
import { connect } from 'react-redux';
import './Login.scss';
import { RootState } from '@src/reducers';
import Button, { ButtonColor } from '@src/components/button/Button';
import Link, { LinkColor } from '@src/components/link/Link';
import { AppActions } from '@src/actions/AppActions';
import { ILoginView } from '@src/reducers/LoginReducer';
import { Svg } from '@src/assets/svg/Svg';
import { __ } from '@src/utils/i18Abstract';
import { M } from '@src/controllers/M';

interface IReduxState {
    isAuthorized: boolean;
    isLoading: boolean;
    username: string;
}

interface IReduxActions {
    init: () => void;
    logout: () => void;
    showOverlay: (view: string) => void;
}

interface IState {}

type IAllProps = IReduxState & IReduxActions;

class Login extends React.Component<IAllProps, IState> {
    componentWillMount() {
        const { init } = this.props;
        init();
    }

    render() {
        const {
            showOverlay,
            isAuthorized,
            username,
            isLoading,
            logout,
        } = this.props;

        const notLoggedIn = () => {
            return [
                <li key="1">
                    <Link
                        title={__('myProfile')}
                        color={LinkColor.White}
                        onClick={() => {
                            showOverlay(ILoginView.login);
                        }}
                    />
                </li>,
                <li key="2">
                    <Button
                        onClick={() => showOverlay(ILoginView.register)}
                        color={ButtonColor.White}
                        title={__('register')}
                    />
                </li>,
            ];
        };

        const userLoggedIn = () => {
            return [
                <li key="1">
                    <Link
                        title={__('myAccount')}
                        color={LinkColor.White}
                        href={M.Config.getCleanMansLink(false)}
                    />
                </li>,
                <li key="2" className="user-info">
                    <span className="user-phone">{username}</span>
                    <a
                        href="#"
                        className="logout-button"
                        onClick={e => {
                            e.preventDefault();
                            logout();
                        }}
                        dangerouslySetInnerHTML={{ __html: Svg.logout(20) }}
                    />
                </li>,
            ];
        };

        return (
            <ul className={`Login-wrap ${isLoading && 'user-info-loading'}`}>
                {isAuthorized ? userLoggedIn() : notLoggedIn()}
            </ul>
        );
    }
}

const mapStateToProps = (state: RootState): IReduxState => {
    return {
        isAuthorized: state.userState.isAuthorized,
        username: state.userState.username,
        isLoading: state.userState.isLoading,
    };
};

const mapDispatchToProps = (dispatch: any): IReduxActions => {
    return {
        init: () => dispatch(AppActions.init()),
        showOverlay: view => dispatch(AppActions.showOverlay(view)),
        logout: () => dispatch(AppActions.logout()),
    };
};

export default connect<IReduxState, IReduxActions, null>(
    mapStateToProps,
    mapDispatchToProps,
)(Login);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/login/Login.tsx